import log from 'loglevel'
import axios from 'axios'

import Category from './category'

import Cache from '../utils/cache'

/* eslint class-methods-use-this: ["off"] */

export default class Supplier {
  constructor() {
    log.info('[INFO] Initialize Supplier Module')
    this.cache = new Cache()

    this.category = new Category()
  }

  fetchSupplierList(params) {
    let parameters = {}

    if (params) {
      parameters = {
        params,
      }
    }

    const result = this.cache.bind(parameters, 10, () => {
      const promise = new Promise((resolve, reject) => {
        axios
          .get('v1/supplier/list/', parameters)
          .then(response => {
            log.debug('[DEBUG] Success to fetch supplier list')
            resolve(response)
          })
          .catch(error => {
            log.error('[ERROR] Fail to fetch supplier list')
            log.error(error)
            reject(error.response)
          })
      })

      return promise
    })

    return result
  }

  fetchSuppliers(params) {
    let parameters = {}

    if (params) {
      parameters = {
        params,
      }
    }

    const result = this.cache.bind(parameters, 10, () => {
      const promise = new Promise((resolve, reject) => {
        axios
          .get('v1/supplier/', parameters)
          .then(response => {
            log.debug('[DEBUG] Success to fetch suppliers')
            resolve(response)
          })
          .catch(error => {
            log.error('[ERROR] Fail to fetch suppliers')
            log.error(error)
            reject(error.response)
          })
      })

      return promise
    })

    return result
  }

  fetchSupplier(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`v1/supplier/${id}/`)
        .then(response => {
          log.debug('[DEBUG] Success to fetch supplier')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to fetch supplier')
          log.error(error)
          reject(error.response)
        })
    })
  }

  updateSupplier(id, supplierData) {
    return new Promise((resolve, reject) => {
      axios
        .put(`v1/supplier/${id}/`, supplierData)
        .then(response => {
          log.debug('[DEBUG] Success to update supplier')
          this.cache.reset()
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to update supplier')
          log.error(error)
          reject(error.response)
        })
    })
  }

  addSupplier(supplierData) {
    return new Promise((resolve, reject) => {
      axios
        .post('v1/supplier/', supplierData)
        .then(response => {
          log.debug('[DEBUG] Success to add supplier')
          this.cache.reset()
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to add supplier')
          log.error(error)
          reject(error.response)
        })
    })
  }

  deleteSupplier(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`v1/supplier/${id}/`)
        .then(() => {
          log.debug('[DEBUG] Success to delete supplier')
          this.cache.reset()
          resolve()
        })
        .catch(error => {
          log.error('[ERROR] Fail to delete supplier')
          log.error(error)
          reject(error.response)
        })
    })
  }
}
